import { BlogCard } from '@/app/components/blog/BlogCard';
import { posts } from '@/app/content/blog';
import { blogListPageContent } from '@/app/content/uiContent';
import { NAVIGATION } from '@/config/constants';
import { Link } from 'react-router-dom';

export function BlogListPage() {
  const [featured, ...rest] = posts;

  return (
    <main id="main-content" tabIndex={-1}>
      {/* Header */}
      <section className="bg-white border-b border-gray-100 py-16 md:py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <p className="text-xs font-semibold text-[#004f4f] uppercase tracking-widest mb-4">
            {blogListPageContent.kicker}
          </p>
          <h1 className="text-[clamp(2rem,4vw,3rem)] font-bold text-slate-900 tracking-tight leading-tight mb-4 max-w-3xl">
            {blogListPageContent.title}
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl leading-relaxed">
            {blogListPageContent.description}
          </p>
        </div>
      </section>

      {/* Posts grid */}
      <section className="py-14 md:py-20 px-6 bg-gray-50" aria-label="Artykuły">
        <div className="max-w-7xl mx-auto">
          {posts.length === 0 ? (
            <p className="text-slate-500 text-center py-20">{blogListPageContent.emptyState}</p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              {featured && <BlogCard post={featured} featured />}
              {rest.map((post) => (
                <BlogCard key={post.slug} post={post} />
              ))}
            </div>
          )}
        </div>
      </section>

      {/* CTA strip */}
      <section className="bg-[#004f4f] py-16 px-6 text-center" aria-label="Zamów audyt">
        <div className="max-w-2xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 tracking-tight">
            {blogListPageContent.ctaHeading}
          </h2>
          <p className="text-teal-100 text-lg mb-8 leading-relaxed">
            {blogListPageContent.ctaDescription}
          </p>
          <Link
            to={`/#${NAVIGATION.contact.id}`}
            className="inline-flex items-center gap-3 bg-white text-[#004f4f] px-8 py-4 rounded-full font-bold hover:bg-teal-50 focus:outline-none focus:ring-4 focus:ring-white focus:ring-offset-4 focus:ring-offset-[#004f4f] transition-colors"
          >
            {blogListPageContent.ctaLabel}
          </Link>
        </div>
      </section>
    </main>
  );
}
